"use client";
import DropdownOne from "@/components/search-dropdown/inner-dropdown/DropdownOne";

import { selectCartItems } from "@/redux/features/cartSlice";
import Loader from "@/components/Loader/Loader";
import axiosInstance from "@/service/axiosInstance";
import { formatAgeForUi, formatDateRange } from "@/utils/utils";
import { useParams, useRouter, useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import eventImage from "../../../../public/assets/images/event-images/image1.jpg";
import {
  addleaderboardFilter,
  leaderboardFilterItems,
} from "@/redux/features/leaderBoardSlice";
import {
  setCount,
  setEvents,
  setLoading,
  setPaginatedEvents,
} from "@/redux/features/eventSlice";
import LeaderboardForEvent from "./LeaderboardForEvent";
import { ClassificationTypes, emptyFilter } from "@/utils/enum";
import Pagination from "@mui/material/Pagination";

const ListingOneArea = ({ academicYear }: { academicYear: string }) => {
  const searchParams = useParams();
  const urlParams = useSearchParams();
  const filter = useSelector(leaderboardFilterItems);

  if (
    searchParams?.slug &&
    Array.isArray(searchParams.slug) &&
    searchParams.slug.length > 1
  ) {
    searchParams.second = decodeURIComponent(searchParams.slug[1]);
  }
  const itemsPerPage = 8;

  const dispatch = useDispatch();
  const router = useRouter();
  const cart = useSelector(selectCartItems);
  const event = useSelector((state: any) => state.events.events);
  const count = useSelector((state: any) => state.events.count);
  const loading = useSelector((state: any) => state.events.eventLoading);
  const [cartData, setCartData] = useState(cart);
  const [currentPage, setcurrentPage] = useState(1);
  const [token, setToken] = useState<string | null>(null);
  const startItem = Math.min(count, (currentPage - 1) * itemsPerPage + 1);
  const endItem = Math.min(count, currentPage * itemsPerPage);
  const getData = async (currentPage: any, filters: any) => {
    try {
      dispatch(setLoading(true));
      console.log("calling api");
      const resp: any = await axiosInstance.post("/leaderboard", {
        sort: "createdAt:desc",
        page: filters.currentPage,
        limit: 8,
        eventsType: filters.eventsType,
        age: filters.age?.value,
        venue_address: filters.location?.value,
        school: filters.school?.value,
        category: filter.category,
        gender: filters.gender,
        eventsMode: filters.eventsMode,
        title: filters.title,
        registrationsOpen: filters.registrationsOpen,
        academicYear: academicYear,
      });
      console.log("🚀 ~ getData ~ resp:", resp);

      let updated = resp.events;
      updated = updated.map((item: any) => ({
        ...item,
        inCart: cart.filter((val) => val.id === item.id)[0]?.inCart || 0,
      }));

      dispatch(setLoading(false));
      dispatch(setEvents(updated));
      dispatch(setCount(resp?.meta.pagination.total));
      handlePageChange(filters.currentPage || currentPage, updated);
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleResetFilter = () => {
    dispatch(addleaderboardFilter(emptyFilter));
    getData(currentPage, filter);
  };

  const handlePageChange = (pageNumber: number, data?: any[]) => {
    setcurrentPage(pageNumber);

    const element = document.getElementById("cart-section");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }

    const startIndex = (pageNumber - 1) * itemsPerPage;
    dispatch(
      setPaginatedEvents(
        data
          ? data.slice(startIndex, startIndex + itemsPerPage)
          : event.slice(startIndex, startIndex + itemsPerPage),
      ),
    );
  };

  const onPageChange = async (
    event: React.ChangeEvent<unknown>,
    value: number,
  ) => {
    setcurrentPage(value);
    const newFilter = {
      ...filter,
      currentPage: value,
    };
    dispatch(addleaderboardFilter(newFilter));
    await getData(value, newFilter);
    handlePageChange(value);
  };

  useEffect(() => {
    const qp: any = urlParams.get("a");
    if (qp !== "false") {
      console.log(filter, "initialfieds");
      getData(currentPage, filter);
    } else {
      dispatch(setLoading(false));
    }
  }, [currentPage]);

  useEffect(() => {
    let matchingCartItem: any;
    const updatedData: any = event.map((item: any) => {
      matchingCartItem = cart.find((val: any) => val.id === item.id);
      return {
        ...item,
        inCart: matchingCartItem ? matchingCartItem.inCart : 0,
      };
    });
    // setData(updatedData);
    dispatch(setEvents(updatedData));
    const startIndex = (currentPage - 1) * itemsPerPage;
    dispatch(
      setPaginatedEvents(
        updatedData.slice(startIndex, startIndex + itemsPerPage),
      ),
    );
  }, [cart]);
  useEffect(() => {
    if (academicYear) {
      const newFilter = {
        ...filter,
        currentPage: 1,
      };
      dispatch(addleaderboardFilter(newFilter));
      getData(1, newFilter);
    }
  }, [academicYear]);

  return (
    <div
      className="property-listing-six bg-pink-two "
      style={{ backgroundColor: "#F5F5FF" }}
    >
      {loading && <Loader />}
      <div className="container container-large">
        <div className="row events-container my-4 my-lg-2">
          <div className="col-lg-8">
            <div className="">
              <div className="listing-header-filter d-sm-flex justify-content-between align-items-center mb-40 lg-mb-30">
                <div>
                  Showing{" "}
                  <span className="color-dark fw-500">
                    {event?.length > 0
                      ? (filter.currentPage - 1) * itemsPerPage + 1
                      : 0}
                  </span>
                  {event?.length > 0 && (
                    <>
                      <span>-</span>
                      <span className="color-dark fw-500">
                        {event?.length > 0
                          ? Math.min(filter.currentPage * itemsPerPage, count)
                          : 0}
                      </span>
                    </>
                  )}{" "}
                  of <span className="color-dark fw-500">{count}</span> Results
                </div>
              </div>
              {event?.length > 0 ? (
                <div className="row gx-xxl-5">
                  {/* {event} */}
                  {event?.map((item: any) => (
                    <div
                      key={item?.id}
                      className="col-md-12 d-flex mb-10 wow fadeInUp"
                    >
                      <div
                        className="listing-card-one border-25 h-100 w-100"
                        style={{
                          border: "1px solid rgba(0, 0, 0, 0.36)",
                          borderRadius: "1rem",
                          padding: "20px",
                          backgroundColor: "#f9f9f9",
                        }}
                      >
                        <div
                          className="options"
                          style={{
                            padding: "10px 10px",
                            backgroundColor: "#f0f0f0",
                          }}
                        >
                          <div
                            className="event-options-first-line"
                            style={{ paddingBottom: "5px" }}
                          >
                            {item?.attributes?.fees_sub_category?.data
                              ?.attributes?.name || "Name Unavailable"}
                          </div>
                          <div
                            className="event-options-second-line"
                            style={{ paddingTop: "5px", paddingBottom: "5px" }}
                          >
                            <span style={{ paddingRight: "8px" }}>
                              {item &&
                              item?.attributes &&
                              item?.attributes?.school &&
                              item?.attributes?.school?.data &&
                              item?.attributes?.school.data?.attributes?.name
                                ? item?.attributes?.school?.data?.attributes
                                    ?.name
                                : "School Name Unavailable"}
                            </span>
                            <span style={{ paddingRight: "8px" }}>
                              {item?.attributes?.fees_category?.data?.attributes
                                ?.name || "N/A"}
                              :{" "}
                              {item?.attributes?.fees_category?.data?.attributes
                                ?.name === ClassificationTypes.Individual
                                ? item?.attributes?.minimum_entry
                                : item?.attributes?.minimum_entry +
                                  "-" +
                                  item?.attributes?.maximum_entry}
                            </span>
                            <span style={{ paddingRight: "8px" }}>
                              | Gender: {item?.attributes?.gender || "N/A"} |
                            </span>
                            <span style={{ paddingRight: "8px" }}>
                              {item?.attributes?.Is_Age_Grade === "Grade"
                                ? (() => {
                                    const from = parseInt(
                                      item?.attributes?.Grade_From?.data
                                        ?.attributes?.short_name || "0",
                                      10,
                                    );
                                    const to = parseInt(
                                      item?.attributes?.Grade_To?.data
                                        ?.attributes?.short_name || "0",
                                      10,
                                    );
                                    return `Grade: ${from} - ${to}`;
                                  })()
                                : `Age: ${formatAgeForUi(
                                    item?.attributes?.age_from || 0,
                                    item?.attributes?.age_to || 0,
                                  )}`}
                            </span>
                            <span style={{ paddingRight: "8px" }}>
                              | Event dates:{" "}
                              {formatDateRange(
                                item?.attributes?.event_start_date,
                                item?.attributes?.event_end_date,
                              )}
                            </span>
                          </div>
                        </div>

                        <div
                          className="winners-section"
                          style={{ marginTop: "30px" }}
                        >
                          <LeaderboardForEvent winner={item.winner} />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{
                    height: "60vh",
                    fontSize: "1.25rem",
                    fontWeight: 500,
                  }}
                >
                  No winners have been declared yet
                </div>
              )}
              {/* <ReactPaginate
                breakLabel="..."
                nextLabel={<Image src={icon} alt="" className="ms-2" />}
                onPageChange={async (e) => {
                  console.log("selected page", e);
                  const newFilter = await new Promise((resolve) => {
                    const prevFilter = { ...filter };
                    const newFilter = {
                      ...prevFilter,
                      currentPage: e.selected + 1,
                    };
                    dispatch(addFilter(newFilter));
                    resolve(newFilter);
                    return newFilter;
                  });
                  setTimeout(() => {}, 5000);
                  // setcurrentPage(e.selected + 1);
                  await getData(e.selected + 1, newFilter);
                }}
                // we need to substract it accepts index
                forcePage={filter.currentPage - 1}
                pageRangeDisplayed={1}
                pageCount={Math.ceil(count / 8)}
                previousLabel={<Image src={icon} alt="" className="ms-2" />}
                renderOnZeroPageCount={null}
                className="pagination-one d-flex align-items-center justify-content-center justify-content-sm-start style-none pt-30"
              /> */}

              <div
                className="my-4"
                style={{
                  display: "flex",
                  alignItems: "stretch",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <div className="text-sm text-black-1500">
                  Showing {startItem} to {endItem} of {count}
                </div>
                <div>
                  <Pagination
                    count={Math.ceil(count / itemsPerPage)}
                    page={currentPage}
                    onChange={onPageChange}
                    shape="rounded"
                    color="primary"
                    sx={{
                      "& .MuiPaginationItem-root.Mui-selected": {
                        backgroundColor: "rgb(63, 65, 209)",
                        color: "#fff",
                      },
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            className="col-lg-4 order-lg-first"
            style={{
              marginBottom: "3.125rem",
            }}
          >
            <div className="advance-search-panel">
              <div className="main-bg">
                <DropdownOne
                  setcurrentPage={setcurrentPage}
                  // handleResetFilter={handleResetFilter}
                  handleResetFilter={() =>
                    dispatch(addleaderboardFilter(emptyFilter))
                  }
                  getData={getData}
                  currentPage={currentPage}
                  isLeaderboard={true}
                  filter={filter}
                  addFilter={addleaderboardFilter}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        @media (max-width: 576px) {
          .listing-card-one {
            padding: 15px;
            min-height: 250px;
          }
          .options {
            padding: 8px 8px;
          }
          .event-options-first-line,
          .event-options-second-line {
            font-size: 14px;
          }
        }

        @media (min-width: 577px) and (max-width: 768px) {
          .listing-card-one {
            padding: 20px;
            min-height: 275px;
          }
          .options {
            padding: 10px 10px;
          }
          .event-options-first-line,
          .event-options-second-line {
            font-size: 16px;
          }
        }

        @media (min-width: 769px) {
          .listing-card-one {
            padding: 25px;
            min-height: 300px;
          }
          .options {
            padding: 12px 12px;
          }
          .event-options-first-line,
          .event-options-second-line {
            font-size: 18px;
          }
        }
      `}</style>
    </div>
  );
};

export default ListingOneArea;
